import React from "react";
import {
  SiAmazonaws,
  SiMicrosoftazure,
  SiAnsible,
  SiPython,
  SiGithub,
  SiTerraform,
} from "react-icons/si";
import bedrockLogo from "../asset/bedrock.png";
import bicepLogo from "../asset/bicep.png";

const stackItems = [
  { name: "AWS", icon: SiAmazonaws },
  { name: "AWS Bedrock", label: "AWS\nBedrock", image: bedrockLogo, imageClass: "h-12 w-12" },
  { name: "Azure", icon: SiMicrosoftazure },
  { name: "Microsoft Bicep", image: bicepLogo, imageClass: "h-16 w-16" },
  { name: "Terraform", icon: SiTerraform },
  { name: "Ansible", icon: SiAnsible },
  { name: "Python", icon: SiPython },
  { name: "GitHub", icon: SiGithub },
];

const TechStack = () => {
  return (
    <section className="section-shell bg-primary px-5 py-20 md:px-8" id="tech-stack">
      <div className="mx-auto w-full max-w-6xl">
        <div className="reveal-up reveal-delay-1 mb-8 text-left">
          <p className="section-kicker mb-3">Tech Stack</p>
          <h2 className="heading-font section-title text-3xl font-bold sm:text-4xl">Tools I work with</h2>
        </div>

        <div className="glass-panel reveal-up reveal-delay-2 rounded-3xl p-6 md:p-9">
          <ol className="grid gap-5 sm:grid-cols-3 lg:grid-cols-4">
            {stackItems.map((item) => {
              const Icon = item.icon;

              return (
                <li
                  key={item.name}
                  tabIndex={0}
                  aria-label={item.name}
                  className="group flex items-center justify-center rounded-2xl border border-slate-500/25 bg-slate-900/35 p-6 text-slate-100 outline-none transition hover:border-teal-300/40 focus-visible:border-teal-300/40"
                >
                  <div className="relative flex h-24 w-24 items-center justify-center overflow-hidden rounded-full border border-slate-400/25 bg-slate-950/60 transition group-hover:-translate-y-0.5 group-hover:border-teal-300/60 group-hover:bg-slate-950/85 group-focus-visible:-translate-y-0.5 group-focus-visible:border-teal-300/60 group-focus-visible:bg-slate-950/85">
                    {item.image ? (
                      <img
                        src={item.image}
                        alt=""
                        className={`${item.imageClass ?? "h-16 w-16"} object-contain object-center transition duration-200 group-hover:scale-90 group-hover:opacity-0 group-focus-visible:scale-90 group-focus-visible:opacity-0`}
                      />
                    ) : (
                      <Icon
                        size={38}
                        className="text-teal-300 transition duration-200 group-hover:scale-90 group-hover:opacity-0 group-focus-visible:scale-90 group-focus-visible:opacity-0"
                        aria-hidden="true"
                      />
                    )}
                    <span className="pointer-events-none absolute inset-0 flex items-center justify-center whitespace-pre-line px-2 text-center text-sm font-semibold leading-tight tracking-wide text-white opacity-0 transition duration-200 group-hover:opacity-100 group-focus-visible:opacity-100">
                      {item.label ?? item.name}
                    </span>
                  </div>
                </li>
              );
            })}
          </ol>
        </div>
      </div>
    </section>
  );
};

export default TechStack;
